import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, inject, Input, OnChanges, SimpleChanges } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RouterLink } from '@angular/router';
import { FuseCardComponent } from '@fuse/components/card';
import { AvatarPipe } from 'app/core/pipes/avatar.pipe';
import { ActivitiesService } from 'app/modules/activities/activities.service';
import { AuthService } from '../../../auth/auth.service';

@Component({
  selector: 'app-my-activity-logs',
  standalone: true,
  imports: [RouterLink, DatePipe, MatIconModule, FuseCardComponent, AvatarPipe, MatProgressSpinnerModule],
  templateUrl: './my-activity-logs.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MyActivityLogsComponent implements OnChanges {
  private Activity = inject(ActivitiesService);
  private auth = inject(AuthService);
  private destroyRef = inject(DestroyRef);
  private cdr = inject(ChangeDetectorRef);

  profile: any;
  dataLoader = false;
  dataList: any = [];
  where: any = [];
  order: any = { created_at: 'desc' };
  include: any = ['causer'];
  paginator: any = {
    itemsPerPage: 5,
    currentPage: 1,
    totalItems: 0,
    form: 0,
    to: 0,
  };
  error: string = null;

  @Input() fromDate: any = '';
  @Input() toDate: any = '';

  ngOnChanges(changes: SimpleChanges) {
    this.dataLoader = true;
    this.profile = this.auth.profile();
    this.getData();
  }

  public getData() {
    this.error = null;
    this.dataList = [];
    this.dataLoader = true;
    this.where = [
      { column: 'causer_id', operator: '=', value: this.profile.id },
      { column: 'causer_type', operator: '=', value: 'user' },
    ];
    if (this.fromDate) this.where.push({ column: 'created_at', operator: '>=', value: this.fromDate });
    if (this.toDate) this.where.push({ column: 'created_at', operator: '<=', value: this.toDate });

    this.Activity.getList({ where: this.where, orderBy: this.order, include: this.include }, this.paginator.currentPage, this.paginator.itemsPerPage)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(
        (data: any) => {
          this.dataList = data.record;
          this.dataLoader = false;
          this.cdr.markForCheck();
        },
        (error: any) => {
          this.error = error.message || 'An error occurred while getting the data';
          this.dataLoader = false;
          this.cdr.markForCheck();
        }
      );
  }
}
